<template>
  <b-alert
    :variant="varient"
    dismissible
    fade
    :show="dismissCountDown"
    @dismiss-count-down="countDownChanged"
  >
    <strong>{{title}}</strong> {{message}}
  </b-alert>
</template>

<script>
export default {

  data() {
    return {
      title: String,
      message: String,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      varient: "success"
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showSuccess(title, message) {
      this.dismissCountDown = this.dismissSecs;
      this.title = title;
      this.message = message;
      this.dismissCountDown = 4;
      this.varient = "success";
    },
    showError(title, message) {
      this.dismissCountDown = this.dismissSecs;
      this.title = title;
      this.message = message;
      this.dismissCountDown = 8;
      this.varient = "danger";
    },
    clear() {
      this.dismissCountDown = 0;
    }
  }
};
</script>
